import { required, Create, SimpleForm, FileInput, FileField } from "react-admin";

const validateRequired = required();

const RepresentativeCreate = (props) => (
  <Create redirect="list" title="Novo Representante" {...props}>
    <SimpleForm>
      <div>
        <FileInput
          source="csv"
          label="CSV Dados de Representantes"
          accept=".csv"
          validate={validateRequired}
        >
          <FileField source="src" title="title" />
        </FileInput>
      </div>
    </SimpleForm>
  </Create>
);

export default RepresentativeCreate;
